// extracted by css-extract-rspack-plugin
module.exports =  {"lti-activity":"Lti-cjwO__lti-activity","activity-title":"Lti-M6g7__activity-title","provider-title":"Lti-Ow55__provider-title"};